export enum EStatus {
  ACTIVE = 'ACTIVE',
  REGISTERED_ON_WEB = 'REGISTERED_ON_WEB',
  REGISTERED_ON_APP = 'REGISTERED_ON_APP',
  REGISTERED_ON_APP_COMPLETED = 'REGISTERED_ON_APP_COMPLETED'
}
